'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _query = require('utilities/query');

var _mapIngredients = require('./map-ingredients.html');

var _mapIngredients2 = _interopRequireDefault(_mapIngredients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _mapIngredients2.default,
  bindings: {
    flex: '@',
    layout: '@',
    query: '<',
    queryMapped: '<'
  },
  controller: function () {
    function MapIngredientsComponent($mdDialog, $scope, IngredientService, LoadingService, ToastService) {
      'ngInject';

      _classCallCheck(this, MapIngredientsComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        IngredientService: IngredientService,
        LoadingService: LoadingService,
        ToastService: ToastService
      });
    }

    _createClass(MapIngredientsComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.columns = [{
          FieldName: 'UserIngredientName',
          DisplayName: 'User Ingredient Name'
        }];

        this.selectedUserIngredients = [];
        this.selectedMappedIngredients = [];
        this.mappedUserIngredients = [];
      }
    }, {
      key: 'refreshUserIngredients',
      value: function refreshUserIngredients() {
        var _this = this;

        this.selectedUserIngredients = [];
        this.selectedMappedIngredients = [];

        var filter = (0, _odataFilterBuilder2.default)().ne('SystemIngredientId', this.selectedSystemIngredient.SystemIngredientId);
        if (this.userIngredientSearchText) {
          filter = filter.and(function (x) {
            return x.contains('UserIngredientName', _this.userIngredientSearchText);
          });
        }

        this.promise = this.IngredientService.searchUserIngredients(_extends({}, this.query, {
          filter: filter.toString()
        }));

        return this.promise.then(function (r) {
          _this.userIngredients = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });
      }
    }, {
      key: 'refreshMappedUserIngredients',
      value: function refreshMappedUserIngredients() {
        var _this2 = this;

        var filter = (0, _odataFilterBuilder2.default)().eq('SystemIngredientId', this.selectedSystemIngredient.SystemIngredientId);
        if (this.mappedUserIngredientSearchText) {
          filter = filter.and(function (x) {
            return x.contains('UserIngredientName', _this2.mappedUserIngredientSearchText);
          });
        }

        this.promiseMapped = this.IngredientService.searchUserIngredients(_extends({}, this.queryMapped, {
          filter: filter.toString()
        }));

        return this.promiseMapped.then(function (r) {
          _this2.mappedUserIngredients = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this2.ToastService.showError(error);
        });
      }
    }, {
      key: 'selectedSystemIngredientChanged',
      value: function selectedSystemIngredientChanged(_ref) {
        var selectedIngredient = _ref.selectedIngredient;

        this.selectedSystemIngredient = selectedIngredient;

        if (selectedIngredient) {
          var promises = [this.refreshUserIngredients(), this.refreshMappedUserIngredients()];

          Promise.all(promises);
        } else {
          this.userIngredients = [];
          this.mappedUserIngredients = [];
          this.userIngredientSearchText = null;
          this.mappedUserIngredientSearchText = null;
        }
      }
    }, {
      key: 'addMapping',
      value: function addMapping(selectedSystemIngredient, selectedUserIngredients) {
        var _this3 = this;

        this.LoadingService.start();
        var userIngredientIds = selectedUserIngredients.map(function (u) {
          return u.UserIngredientId;
        });

        this.IngredientService.addSystemIngredientMapping(selectedSystemIngredient.SystemIngredientId, userIngredientIds).then(function () {
          _this3.selectedUserIngredients = [];

          var promises = [_this3.refreshUserIngredients(), _this3.refreshMappedUserIngredients()];

          Promise.all(promises).then(function () {
            return _this3.ToastService.showSuccess('User ingredients mapped successfully!');
          });
        }).catch(function (error) {
          return _this3.ToastService.showError(error);
        }).finally(function () {
          return _this3.LoadingService.stop();
        });
      }
    }, {
      key: 'removeMapping',
      value: function removeMapping(selectedSystemIngredient, selectedUserIngredients) {
        var _this4 = this;

        this.LoadingService.start();
        var userIngredientIds = selectedUserIngredients.map(function (u) {
          return u.UserIngredientId;
        });

        this.IngredientService.removeSystemIngredientMapping(selectedSystemIngredient.SystemIngredientId, userIngredientIds).then(function () {
          _this4.selectedMappedIngredients = [];

          var promises = [_this4.refreshUserIngredients(), _this4.refreshMappedUserIngredients()];

          Promise.all(promises).then(function () {
            return _this4.ToastService.showSuccess('User ingredients unmapped successfully!');
          });
        }).catch(function (error) {
          return _this4.ToastService.showError(error);
        }).finally(function () {
          return _this4.LoadingService.stop();
        });
      }
    }, {
      key: 'onIngredientSearchTextChanged',
      value: function onIngredientSearchTextChanged(_ref2) {
        var searchText = _ref2.searchText;

        this.selectedUserIngredients = [];
        this.userIngredientSearchText = searchText;
        this.refreshUserIngredients();
      }
    }, {
      key: 'onQueryChanged',
      value: function onQueryChanged(_ref3) {
        var query = _ref3.query;

        this.selectedUserIngredients = [];
        this.query = query;
        this.refreshUserIngredients();
      }
    }, {
      key: 'onMappedIngredientSearchTextChanged',
      value: function onMappedIngredientSearchTextChanged(_ref4) {
        var searchText = _ref4.searchText;

        this.selectedMappedIngredients = [];
        this.mappedUserIngredientSearchText = searchText;
        this.refreshMappedUserIngredients();
      }
    }, {
      key: 'onMappedQueryChanged',
      value: function onMappedQueryChanged(_ref5) {
        var query = _ref5.query;

        this.selectedMappedIngredients = [];
        this.queryMapped = query;
        this.refreshMappedUserIngredients();
      }
    }]);

    return MapIngredientsComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/map-ingredients/map-ingredients.component.js